/* tom&pat 8.4 — Produktseiten- und Warenkorb-Bedienung (klein, isoliert, rückbaubar).
   tom&pat 9.9 (Theo, 08.10.2026, Rundgang Aufgaben Zeilen 21–24):
   - Das seit Runde 2 zu 8.8 abgeschaltete Umhängen von Unterzeile/Kaufargumenten in eine
     Mobil-Box (mobileProduktkopfErgaenzen, TP_MOBILE_BOX_PER_JS) ist entfernt – Titel, Sterne
     und Preis stehen serverseitig vor der Galerie (sections/main-product.liquid).
   - Neu: Vorauswahl der meistgekauften Variante, verständliche Fehlermeldung beim
     Ergänzungs-Kauf im Warenkorb. */

/* Zeile 23 / CEO-Runde Punkt 3: meistgekaufte Variante vorausgewählt.
   Das Theme kann die Vorauswahl nicht serverseitig ändern (Shopify nimmt immer die erste lieferbare
   Variante, solange die Adresse kein ?variant= trägt; welche Variante ein ?option_values=-Aufruf
   setzt, ist nicht sicher erkennbar). Deshalb hier: Trägt eine Pille data-tp-meistgekauft
   (snippets/variant-picker.liquid) und steht in der Adresse weder variant= noch option_values=,
   wird genau diese Pille einmal angewählt. Der Rest läuft über den normalen Variantenwechsel von
   product-info.js (Preis, Knopf, Lagerstatus, Sticky-Leiste, Adresse mit ?variant=).
   Dauerhaft sauberer wäre die Variantenreihenfolge im Admin (Sam, mit Patricks GO); dann greift
   dieser Schritt nicht mehr, weil die Pille schon gewählt ist.
   tom&pat 10.0 (Theo, 09.10.2026, Folgenprüfung C14/B6, Auftrag Sven): Vorher läuft ein zweiter Schritt.
   Trägt die Adresse ?variant=<alte ID> und kennt die Auswahl dafür eine Zuordnung
   (script[data-tp-alte-varianten], nur /products/menstruationsschwamm, snippets/variant-picker.liquid),
   werden die Werte der neuen Variante angewählt – über denselben Variantenwechsel (kein Neuladen,
   kein focus(), kein Scrollen); die Adresse trägt danach per history.replaceState die neue ID.
   Dann entfällt die Meistgekauft-Vorauswahl (die Adresse hat ja eine Variante).
   tom&pat 10.4 (Theo, 10.10.2026, Preis-Sprung): Die meistgekaufte Variante wählt jetzt schon der Server
   (snippets/tp-startvariante.liquid); die Pille ist beim Laden angehakt, der Preis steht sofort. Dieser Schritt
   greift deshalb nur noch, wenn die Pille ausnahmsweise nicht angehakt ist (Rückfall, gleiche Prüfungen wie bisher).
   tom&pat 13.4b (Theo, 25.10.2026, Befund H5, Messung Uwe/Costa 15-funktionstest-13.4): Dieser Rückfall hat eine früh
   angetippte Größe überschrieben: Wer vor dem Laden der Skripte z. B. 17-18 cm antippte, hatte danach wieder die
   Startvariante 15-16 cm im Formular, in der Anzeige und im Korb (Honeycomb und Menstruationsschwamm, die beiden Produkte
   mit data-tp-meistgekauft). Jetzt greifen beide Vorauswahlen nur, wenn die Kundin (oder der Browser beim Zurückgehen)
   noch nichts anders angehakt hat als der Server (checked == defaultChecked an jedem Knopf), und die Meistgekauft-
   Vorauswahl nur, wenn der Server die Pille nicht schon selbst angehakt hat (defaultChecked). Die angetippte Größe
   holt assets/variants-picker.js nach (tpVorauswahlNachholen). */
(function () {
  'use strict';

  /* 13.4b: Hat jemand vor dem Start schon anders gewählt als der Server? Dann keine automatische Vorauswahl. */
  function eigeneWahl(picker) {
    return Array.prototype.some.call(picker.querySelectorAll('input[type="radio"]'), function (radio) {
      return radio.checked !== radio.defaultChecked;
    });
  }

  /* A4 (Fiete-Korrektur 09.10.2026): Start nicht mehr per setTimeout 0 - tom-pat-84.js laedt im Kopf,
     product-info.js und variants-picker.js erst spaeter (main-product.liquid). Jetzt erst, wenn beide
     Elemente angemeldet sind (customElements.whenDefined), und hoechstens einmal. Nach dem Variantenwechsel
     wird geprueft, ob das versteckte Formularfeld name="id" wirklich die Zielvariante traegt. Wenn nicht,
     wird nichts erzwungen; steht nur noch unser Haken (z. B. Abruf gescheitert), geht er zurueck auf die
     vorher gewaehlte Pille, damit Pille und Formular dieselbe Variante zeigen. */
  var ausgeloest = false;

  function formularVariante(product) {
    var formular = document.getElementById('product-form-' + product.dataset.section);
    var feld = formular ? formular.querySelector('input[name="id"]') : null;
    return feld ? String(feld.value) : '';
  }

  function angezeigteVariante(product) {
    var daten = product.querySelector('variant-picker:not([data-replaced]) [data-selected-variant]');
    if (!daten) return null;
    try {
      return JSON.parse(daten.textContent);
    } catch (fehler) {
      return null;
    }
  }

  /* A5 (09.10.2026): kein Ladesprung - focus() auf der Zielpille waehrend der Vorauswahl auslassen. */
  function fokusSperren(zielId, product) {
    var original = HTMLElement.prototype.focus;
    var aktiv = true;
    var timer = null;
    function huelle() {
      if (aktiv && this && this.id === zielId) return;
      return original.apply(this, arguments);
    }
    function kundenwahl(event) {
      var feld = event.target;
      if (event.isTrusted && feld && feld.closest && feld.closest('variant-picker') && product.contains(feld)) freigeben();
    }
    function freigeben() {
      if (!aktiv) return;
      aktiv = false;
      window.clearTimeout(timer);
      document.removeEventListener('change', kundenwahl, true);
      if (HTMLElement.prototype.focus === huelle) HTMLElement.prototype.focus = original;
    }
    HTMLElement.prototype.focus = huelle;
    document.addEventListener('change', kundenwahl, true);
    timer = window.setTimeout(freigeben, 5000);
    return freigeben;
  }

  function meistgekauftVorauswahl() {
    if (ausgeloest) return;
    ausgeloest = true;
    if (/[?&](variant|option_values)=/.test(window.location.search)) return;
    var product = document.querySelector('product-info[id^="MainProduct"]');
    if (!product || typeof product.whenVariantSettled !== 'function') return;
    var picker = product.querySelector('variant-picker');
    if (!picker) return;
    var ziel = picker.querySelector('input[type="radio"][data-tp-meistgekauft]');
    if (!ziel || ziel.checked || ziel.disabled) return;
    if (ziel.defaultChecked || eigeneWahl(picker)) return;
    var zielWert = ziel.value;
    var gruppe = picker.querySelectorAll('input[type="radio"][name="' + ziel.name + '"]');
    var vorher = [];
    Array.prototype.forEach.call(gruppe, function (radio) {
      if (radio.checked) vorher.push(radio);
      radio.checked = false;
    });
    ziel.checked = true;
    var freigeben = ziel.id ? fokusSperren(ziel.id, product) : function () {};
    var verlauf;
    try {
      ziel.dispatchEvent(new Event('change', { bubbles: true }));
      verlauf = product.whenVariantSettled();
    } catch (fehler) {
      freigeben();
      return;
    }

    verlauf.then(function () {
      freigeben();
      var variante = angezeigteVariante(product);
      var passt = !!variante &&
        String(variante.id) === formularVariante(product) &&
        Array.isArray(variante.options) &&
        variante.options.indexOf(zielWert) !== -1;
      if (passt) return;
      if (ziel.isConnected && ziel.checked && !ziel.closest('[data-replaced]')) {
        ziel.checked = false;
        vorher.forEach(function (radio) { radio.checked = true; });
      }
    }, freigeben);
  }

  /* 10.0 C14/B6: alte Varianten-ID in der Adresse -> passende neue Variante (siehe Kopf). */
  var alteAusgeloest = false;

  function alteVarianteVorauswahl() {
    if (alteAusgeloest) return false;
    alteAusgeloest = true;
    var treffer = /[?&]variant=(\d+)(?:&|$)/.exec(window.location.search);
    if (!treffer) return false;
    var product = document.querySelector('product-info[id^="MainProduct"]');
    if (!product || typeof product.whenVariantSettled !== 'function') return false;
    var picker = product.querySelector('variant-picker');
    var daten = picker ? picker.querySelector('script[data-tp-alte-varianten]') : null;
    if (!daten) return false;
    if (eigeneWahl(picker)) return true;
    var tabelle;
    try {
      tabelle = JSON.parse(daten.textContent);
    } catch (fehler) {
      return false;
    }
    var ziel = tabelle && Object.prototype.hasOwnProperty.call(tabelle, treffer[1]) ? tabelle[treffer[1]] : null;
    if (!ziel || !ziel.id || !Array.isArray(ziel.o)) return false;
    var felder = Array.prototype.slice.call(picker.querySelectorAll('[data-picker-field]'));
    if (felder.length !== ziel.o.length) return false;
    var radios = [];
    for (var i = 0; i < felder.length; i += 1) {
      var passend = Array.prototype.filter.call(felder[i].querySelectorAll('input[type="radio"]'), function (radio) {
        return radio.value === ziel.o[i];
      });
      if (!passend.length) return false;
      radios.push(passend[0]);
    }
    var vorher = [];
    felder.forEach(function (feld, j) {
      Array.prototype.forEach.call(feld.querySelectorAll('input[type="radio"]'), function (radio) {
        if (radio.checked) vorher.push(radio);
        radio.checked = radio === radios[j];
      });
    });
    var ausloeser = radios[radios.length - 1];
    var freigeben = ausloeser.id ? fokusSperren(ausloeser.id, product) : function () {};
    var verlauf;
    try {
      ausloeser.dispatchEvent(new Event('change', { bubbles: true }));
      verlauf = product.whenVariantSettled();
    } catch (fehler) {
      freigeben();
      return true;
    }
    verlauf.then(function () {
      freigeben();
      var variante = angezeigteVariante(product);
      var passt = !!variante && String(variante.id) === String(ziel.id) && formularVariante(product) === String(ziel.id);
      if (passt) {
        if (!new RegExp('[?&]variant=' + ziel.id + '(?:&|$)').test(window.location.search)) {
          window.history.replaceState(window.history.state, '', window.location.pathname + '?variant=' + ziel.id + window.location.hash);
        }
        return;
      }
      radios.forEach(function (radio) {
        if (radio.isConnected && !radio.closest('[data-replaced]')) radio.checked = false;
      });
      vorher.forEach(function (radio) {
        if (radio.isConnected) radio.checked = true;
      });
    }, freigeben);
    return true;
  }

  function vorauswahl() {
    if (alteVarianteVorauswahl()) return;
    meistgekauftVorauswahl();
  }

  function starten() {
    if (!window.customElements || typeof window.customElements.whenDefined !== 'function' || typeof Promise === 'undefined') return;
    if (!document.querySelector('product-info[id^="MainProduct"] variant-picker input[type="radio"][data-tp-meistgekauft], product-info[id^="MainProduct"] variant-picker script[data-tp-alte-varianten]')) return;
    Promise.all([
      window.customElements.whenDefined('variant-picker'),
      window.customElements.whenDefined('product-info')
    ]).then(vorauswahl);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', starten, { once: true });
  } else {
    starten();
  }
})();

/* tom&pat 10.4 (Theo, 10.10.2026, Preis-Sprung): Ohne ?variant= zeigt der Server bei Honeycomb und Menstruationsschwamm
   die meistgekaufte Variante (snippets/tp-startvariante.liquid). Damit eine spätere Wahl der Kundin nie auf diese
   Startvariante zurückfällt, fragt die Produktseite bei diesen Produkten den Abschnitt mit ?variant=<ID> der gewählten
   Kombination an statt mit option_values (nur ?variant= setzt product.selected_variant verlässlich). Die Zuordnung Werte
   -> ID kommt aus script[data-tp-varianten] (snippets/variant-picker.liquid), die Werte aus den angeklickten Feldern
   (data-option-value-id). Gibt es keine passende Variante, bleibt die Anfrage unverändert. Alle anderen Produkte und
   ganze Seitenwechsel (Kombi-Produkte): unverändert. */
(function () {
  'use strict';

  function varianteZurWahl(info, werteIds) {
    var picker = info.querySelector('variant-picker:not([data-replaced])');
    var daten = picker ? picker.querySelector('script[data-tp-varianten]') : null;
    if (!daten || !Array.isArray(werteIds) || !werteIds.length) return null;
    var liste;
    try {
      liste = JSON.parse(daten.textContent);
    } catch (fehler) {
      return null;
    }
    if (!Array.isArray(liste)) return null;
    var felder = picker.querySelectorAll('[data-option-value-id]');
    var namen = [];
    for (var i = 0; i < werteIds.length; i += 1) {
      var name = null;
      for (var f = 0; f < felder.length; f += 1) {
        if (String(felder[f].getAttribute('data-option-value-id')) === String(werteIds[i])) {
          name = felder[f].value;
          break;
        }
      }
      if (name === null) return null;
      namen.push(name);
    }
    for (var j = 0; j < liste.length; j += 1) {
      var werte = liste[j] && liste[j].o;
      if (!Array.isArray(werte) || werte.length !== namen.length) continue;
      var gleich = true;
      for (var k = 0; k < werte.length; k += 1) {
        if (werte[k] !== namen[k]) { gleich = false; break; }
      }
      if (gleich && liste[j].i) return String(liste[j].i);
    }
    return null;
  }

  function einbauen() {
    var Klasse = window.customElements.get('product-info');
    if (!Klasse || !Klasse.prototype || Klasse.prototype.tpVarianteAnfrage) return;
    var original = Klasse.prototype.buildRequestUrlWithParams;
    if (typeof original !== 'function') return;
    Klasse.prototype.buildRequestUrlWithParams = function (url, werteIds, ganzeSeite) {
      var adresse = original.apply(this, arguments);
      try {
        if (ganzeSeite || /[?&]variant=/.test(adresse) || !/[?&]option_values=/.test(adresse)) return adresse;
        var id = varianteZurWahl(this, werteIds);
        if (!id || !/^\d+$/.test(id)) return adresse;
        return adresse.replace(/([?&])option_values=[^&]*/, '$1variant=' + id);
      } catch (fehler) {
        return adresse;
      }
    };
    Klasse.prototype.tpVarianteAnfrage = true;
  }

  if (window.customElements && typeof window.customElements.whenDefined === 'function' && typeof Promise !== 'undefined') {
    window.customElements.whenDefined('product-info').then(einbauen);
  }
})();

/* Warenkorb-Runde 2: "Das ergänzt sich gut" / 9.9: "Noch X € bis Gratisversand – dazu passt" —
   ein Klick legt die Empfehlung in den Warenkorb.
   Schubfach: vorhandene Theme-Mechanik (Sections-Rerender über cartUpdate, Schubfach bleibt offen);
   der Container .tp-cart-dynamik wird dabei vom Server neu aufgebaut (cart-drawer.js).
   Warenkorbseite: Seite neu laden, damit Tabelle und Empfehlung serverseitig frisch stehen.
   9.9 (Rundgang Aufgaben Zeile 21): Scheitert das Hinzufügen (Netz, Lager, Shopify-Fehler), erscheint
   eine verständliche Meldung direkt unter der Empfehlung; der Knopf wird wieder frei. */
(function () {
  'use strict';

  function meldungZeigen(button, text) {
    var box = button.closest('[data-tp-pairing]');
    var meldung = box ? box.querySelector('.tp-cart-pairing__meldung') : null;
    if (!meldung) {
      window.alert(text);
      return;
    }
    meldung.textContent = text;
    meldung.hidden = false;
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-tp-pairing-add]');
    if (!button || button.disabled) return;
    event.preventDefault();

    var variantId = button.getAttribute('data-tp-pairing-add');
    if (!variantId) return;

    var name = button.getAttribute('data-tp-pairing-name') || 'Der Artikel';
    var meldungAlt = button.closest('[data-tp-pairing]') && button.closest('[data-tp-pairing]').querySelector('.tp-cart-pairing__meldung');
    if (meldungAlt) { meldungAlt.hidden = true; meldungAlt.textContent = ''; }

    button.disabled = true;
    button.classList.add('btn--loading');

    var settings = window.FoxThemeSettings || {};
    var onCartPage = settings.template === 'cart';
    var drawer = document.querySelector('cart-drawer');

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    if (!onCartPage && drawer && typeof drawer.getSectionsToRender === 'function') {
      var ids = drawer.getSectionsToRender(true).map(function (section) { return section.id; });
      var einmalig = ids.filter(function (id, index) { return ids.indexOf(id) === index; });
      formData.append('sections', einmalig.join(','));
      formData.append('sections_url', window.location.pathname);
    }

    fetch((settings.routes && settings.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (response) { return response.json(); })
      .then(function (response) {
        if (response.status) {
          /* A4 (Fiete-Korrektur 09.10.2026): nur Shopifys eigener Grund (description/message der Antwort) */
          var fehler = new Error('cart/add');
          var beschreibung = typeof response.description === 'string' ? response.description.trim() : '';
          var nachricht = typeof response.message === 'string' ? response.message.trim() : '';
          fehler.tpShopifyGrund = beschreibung || nachricht;
          throw fehler;
        }
        if (!onCartPage && drawer && window.FoxThemeEvents && typeof PUB_SUB_EVENTS !== 'undefined') {
          window.FoxThemeEvents.emit(PUB_SUB_EVENTS.cartUpdate, response);
        } else {
          window.location.reload();
        }
      })
      .catch(function (error) {
        button.disabled = false;
        button.classList.remove('btn--loading');
        var grund = error && typeof error.tpShopifyGrund === 'string' ? error.tpShopifyGrund : '';
        var text = name + ' konnte nicht in den Warenkorb gelegt werden. Bitte versuchen Sie es noch einmal.';
        if (grund) text += ' (' + grund + ')';
        meldungZeigen(button, text);
      });
  });
})();

/* tom&pat 13.7 (Theo, 29.10.2026, Aufgabe 21, Teil D; Patrick 29.10.2026 "Nur positive"): Produktkarten mit mehreren
   Groessen (snippets/pat-schnellwahl.liquid, Auswahl mit data-tp-preiszeile; nicht die Menstruationsprodukte - Ausnahme
   bis 17.11.2026 - und nicht Produkte mit einer Variante). Die Auswahl zeigt nur noch den Variantentitel (bisher
   "13-14 cm - 24,95 EUR", in den zweispaltigen Karten bei 320/390 px abgeschnitten). Vorgewaehlt bleibt wie bisher die
   erste lieferbare Groesse, die Preiszeile zeigt dazu "ab ...". Waehlt die Kundin eine Groesse, zeigt die Preiszeile genau
   deren Preis (data-tp-preis an der Option, Ziel [data-tp-betrag] in snippets/product-card.liquid). Stellt der Browser
   beim Zurueck/Vorwaerts oder Neuladen eine andere als die vorgewaehlte Groesse wieder her (oder gab es schon eine Wahl),
   wird der Preis nachgezogen.
   Ohne JavaScript bleibt "ab ...". Nichts wird gesperrt: "In den Warenkorb" legt wie bisher die angezeigte Groesse ein. */
(function () {
  'use strict';
  var AUSWAHL = 'select.tp-schnellwahl__select[data-tp-preiszeile]';

  function preisSetzen(feld) {
    var fuss = feld.closest('.tp-card-foot');
    var betrag = fuss ? fuss.querySelector('[data-tp-betrag]') : null;
    if (!betrag) return;
    if (!betrag.hasAttribute('data-tp-ab')) betrag.setAttribute('data-tp-ab', betrag.textContent);
    var option = feld.options[feld.selectedIndex];
    var text = (option && option.getAttribute('data-tp-preis')) || betrag.getAttribute('data-tp-ab');
    if (betrag.textContent !== text) betrag.textContent = text;
  }

  document.addEventListener('change', function (event) {
    var feld = event.target;
    if (feld && feld.matches && feld.matches(AUSWAHL)) preisSetzen(feld);
  });

  function nachziehen() {
    Array.prototype.forEach.call(document.querySelectorAll(AUSWAHL), function (feld) {
      var option = feld.options[feld.selectedIndex];
      var fuss = feld.closest('.tp-card-foot');
      var schonGewaehlt = !!(fuss && fuss.querySelector('[data-tp-ab]'));
      if (option && (!option.defaultSelected || schonGewaehlt)) preisSetzen(feld);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', nachziehen, { once: true });
  else nachziehen();
  window.addEventListener('pageshow', nachziehen);
})();
